export default __webpack_public_path__ + "static/media/right_icon.1b60435c.png";